import React from 'react';
import { Countdown, Button, TrustBar } from './Shared';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function CtaAndFooter() {
  return <>
      {/* SECCIÓN 12: LOS DOS CAMINOS */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-11">
        <div className="max-w-3xl mx-auto" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep mb-12" data-id="element-13">
            Hay dos caminos frente a vos ahora mismo.
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-14">
            <div className="bg-red-50 border border-red-100 p-8 rounded-3xl" data-id="element-15">
              <h3 className="font-bold text-red-600 mb-4 text-xl" data-id="element-16">
                El primero:
              </h3>
              <p className="text-brand-text font-medium leading-relaxed" data-id="element-17">
                El próximo domingo a la tarde, vas a estar otra vez frente a la
                computadora buscando material. Buscando fichas que no estén
                alineadas al EBI. Buscando rúbricas que no tengan los 4 niveles.
                Perdiendo horas que no vas a recuperar. Y si querías generar
                ingresos extra con tus horas libres, vas a seguir pensando en
                hacerlo sin el sistema que lo hace posible.
              </p>
            </div>

            <div className="bg-brand-lightBlue border border-brand-sky p-8 rounded-3xl" data-id="element-18">
              <h3 className="font-bold text-brand-blue mb-4 text-xl" data-id="element-19">
                El segundo:
              </h3>
              <p className="text-brand-text font-medium leading-relaxed" data-id="element-20">
                Hoy descargás Aula de Éxitos. Esta tarde organizás todo el año.
                El próximo domingo mientras tus colegas planifican vos tomás
                mate con tu familia. Y si querés monetizar tu formación docente,
                tenés en tus manos las 1.600 actividades · las rúbricas · los
                registros de progreso y la guía completa para hacerlo desde hoy
                mismo.
              </p>
            </div>
          </div>

          <p className="text-xl font-bold text-brand-deep mb-2" data-id="element-21">
            El material ya existe. El sistema ya está probado.
          </p>
          <p className="text-lg text-brand-text mb-2" data-id="element-22">
            Las +500 maestras uruguayas que ya lo usan ya tomaron la decisión.
          </p>
          <p className="text-2xl font-display font-bold text-brand-orange" data-id="element-23">
            Solo falta la tuya.
          </p>
        </div>
      </section>

      {/* SECCIÓN 13: CTA FINAL */}
      <section className="py-16 px-4 bg-brand-deep text-center text-white relative overflow-hidden" data-id="element-24">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-brand-blue/40 rounded-full blur-[120px] pointer-events-none" data-id="element-25"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-8" data-id="element-27">
            🟠 ELEGÍ TU AULA DE ÉXITOS AHORA
          </h2>

          <div className="bg-white/10 border border-white/15 rounded-2xl p-6 mb-8" data-id="element-28">
            <Countdown data-id="element-29" />
            <p className="text-brand-sky font-medium mt-4" data-id="element-30">
              Después vuelve a su precio real y no vuelve esta oferta.
            </p>
          </div>

          <div className="max-w-md mx-auto mb-8" data-id="element-31">
            <Button className="py-5 text-xl" data-id="element-32">
              🌟 QUIERO MI AULA DE ÉXITOS AHORA
            </Button>
            <div className="mt-6 text-brand-sky" data-id="element-33">
              <TrustBar tone="dark" data-id="element-34" />
            </div>
          </div>

          <div className="font-bold text-brand-orange" data-id="element-35">
            +500 docentes uruguayas ya confían
          </div>
        </div>
      </section>

      {/* SECCIÓN 14: CIERRE EMOCIONAL Y FOOTER */}
      <footer className="bg-[#0c0a09] text-gray-400 py-16 px-4 text-center border-t border-white/10" data-id="element-36">
        <div className="max-w-4xl mx-auto" data-id="element-37">
          <div className="mb-12 max-w-lg mx-auto" data-id="element-38">
            <p className="text-lg text-gray-300 mb-6 leading-relaxed font-medium" data-id="element-39">
              Enseñar no debería costarte todos los domingos del año.
              <br data-id="element-40" />
              <br data-id="element-41" />
              Tu formación no debería generar menos ingresos que un oficio sin
              título.
              <br data-id="element-42" />
              <br data-id="element-43" />Y tu vocación no debería ser el motivo por el que nunca
              tenés tiempo libre.
            </p>
            <p className="text-xl text-white font-bold mb-6" data-id="element-44">
              Aula de Éxitos no cambia lo que sos.
              <br data-id="element-45" />
              <span className="text-brand-orange" data-id="element-46">
                Cambia lo que podés hacer con lo que sos.
              </span>
            </p>
            <p className="text-lg text-brand-sky font-medium" data-id="element-47">
              El año resuelto.
              <br data-id="element-48" />
              El negocio en tus manos.
              <br data-id="element-49" />
              La decisión es tuya.
            </p>
          </div>

          <div className="text-2xl font-bold text-white mb-2" data-id="element-50">
            🌟 Tu Fénix Digital
          </div>
          <p className="text-brand-orange font-bold text-sm tracking-widest uppercase mb-8" data-id="element-51">
            AULA DE ÉXITOS · Edición 2026
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8" data-id="element-52">
            <a href="#" className="hover:text-white transition-colors" data-id="element-53">
              www.tufenixdigital.store
            </a>
          </div>

          <div className="flex justify-center gap-6 mb-8" data-id="element-54">
            <a href="#" className="hover:text-white transition-colors" data-id="element-55">
              <Facebook className="w-6 h-6" data-id="element-56" />
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-57">
              <Instagram className="w-6 h-6" data-id="element-58" />
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-59">
              <Youtube className="w-6 h-6" data-id="element-60" />
            </a>
          </div>

          <div className="text-sm" data-id="element-61">
            © 2026 Tu Fénix Digital — Todos los derechos reservados
          </div>
        </div>
      </footer>
    </>;
}